import { getIsProduction } from "@faire/help-center-utils/serialized-data/getEnvName";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const RequestIntegrationIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="We offer several direct integrations to help you seamlessly connect your business software to Faire. If you don’t find an integration that meets your needs, contact our support team to request one."
          description={{
            text: "Introduction to requesting an integration",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Please include details about the functionality you’re looking for or the partner you’d like to integrate with. This information helps us gather feedback and guide future partnership decisions."
          description={{
            text: "Details for requesting an integration",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="If your team has the technical resources to develop an integration, they can start the process by visiting our <LinkFormatting>Developers</LinkFormatting> page."
          values={{
            LinkFormatting: DevelopersLinkFormatting,
          }}
          description={{
            text: "Information for teams with technical resources",
          }}
        />
      </Typography>
    </Column>
  );
};

const DevelopersLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={
      getIsProduction()
        ? `https://developers.faire.com`
        : `https://developers.faire-stage.com`
    }
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);
